(function () {
  'use strict';
  const key = 'gifted_pending_history_v1';
  const memory = new Map();
  let inFlight;
  function read() {
    let saved=[];
    try {saved=JSON.parse(localStorage.getItem(key)||'[]');}catch(_){}
    if(!Array.isArray(saved))saved=[];
    const entries=new Map(saved.filter(x=>x && typeof x.token==='string' && x.createdAt>Date.now()-86400000).map(x=>[x.token,x]));
    for(const [token,row] of memory)entries.set(token,row);
    return [...entries.values()];
  }
  function write(rows) {
    memory.clear(); rows.forEach(row=>memory.set(row.token,row));
    try {localStorage.setItem(key,JSON.stringify(rows));}catch(_){}
  }
  function enqueue(customerId,token) {
    if(!customerId || !token)return;
    const rows=read();if(!rows.some(x=>x.token===token))rows.push({customerId:String(customerId),token,createdAt:Date.now()});
    write(rows);
  }
  async function recover(customerId) {
    if(inFlight)return inFlight;
    inFlight=(async()=>{
      const recovered=[];
      for(const entry of read().filter(x=>x.customerId===String(customerId))) {
        for(let attempt=0;attempt<3;attempt++) {
          try {
            const response=await fetch(window.CustomifyApi?.url('/api/retry-generation-save') || 'https://lumlyusa.vercel.app/api/retry-generation-save',{
              method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({token:entry.token}),signal:AbortSignal.timeout(30000)
            });
            if(response.status===403) {write(read().filter(x=>x.token!==entry.token));break;}
            const result=await response.json();
            if(response.ok && result.success===true && result.debug?.metafieldUpdateSuccess===true) {
              write(read().filter(x=>x.token!==entry.token));recovered.push(entry.token);break;
            }
          }catch(_){}
          if(attempt<2)await new Promise(resolve=>setTimeout(resolve,1000*(attempt+1)));
        }
      }
      return recovered;
    })();
    try{return await inFlight;}finally{inFlight=null;}
  }
  function attachPreview(image,card) {
    let placeholder;
    function failed() {
      if(placeholder)return;
      image.hidden=true;
      placeholder=document.createElement('div');
      placeholder.className='generation-preview-pending';
      placeholder.style.cssText='min-height:180px;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:12px;padding:20px;background:#f5f5f5;text-align:center';
      const text=document.createElement('p');
      const german=/^de/i.test(window.CustomifyI18n?.locale || document.documentElement.lang || 'en');
      text.textContent=german?'Die Vorschau konnte noch nicht geladen werden.':'The preview could not load yet.';
      const button=document.createElement('button');button.type='button';
      button.textContent=german?'Erneut laden':'Reload preview';
      button.addEventListener('click',event=>{
        event.stopPropagation();image.hidden=false;
        placeholder.remove();placeholder=null;
        const url=new URL(image.src);url.searchParams.set('previewRetry',Date.now());image.src=url.href;
      });
      placeholder.append(text,button);image.after(placeholder);
    }
    image.addEventListener('error',failed);
    image.addEventListener('load',()=>{image.hidden=false;if(placeholder){placeholder.remove();placeholder=null;}});
    if(image.complete && image.naturalWidth===0 && image.getAttribute('src'))failed();
  }
  window.CustomifyHistoryRecovery={enqueue,recover,attachPreview};
})();
